// test99
(99 && 0);
